<template>
    <v-layout class="dialog-container" row justify-center>
      <v-card max-width="500">
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0 primary--text">

            </h3>
            <h3 class="headline mb-0">Mais informações</h3>
          </div>
        </v-card-title>

        <v-card-text class="pb-1">
          <span
            class="grey--text"
          >Para dividir o pagamento com outras pessoas, informe um valor parcial no campo valor a pagar</span>
        </v-card-text>

        <v-card-text class="pb-1 pt-1">
          <span
            class="grey--text"
          >O seu pagamento será processado e sua compra continuará pendente até que o valor total do pedido seja pago</span>
        </v-card-text>

        <v-card-text class="pb-1 pt-1">
          <span
            class="grey--text"
          >Você receberá um link para compartilhar e permitir que outras pessoas adicionem pagamentos ao seu pedido</span>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" class="normal-text" flat outline round @click="$emit('closeDialog')">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
</template>

<script>
export default {
    data() {
        return {
           dialog: false
        }
    },
    computed: {
        showResetPurchase() {
            return this.$store.getters.showResetPurchase;
        },
        cartProducts() {
            return this.$store.getters.cartProducts;
        },
    },
    mounted() {
    },
    methods: {
        closeDialog() {
            this.$store.dispatch('setResetPurchase', false);
        },
        async reset() {
          const evento = this.$store.getters.eventID;
          const checkoutState = JSON.parse(localStorage.getItem(`checkoutState`)) || {};
          this.cartProducts.forEach(product => {
            product.forEach(async el => {
              if(el.seats) {
                el.seats.forEach (async sc => {
                  await this.$store.dispatch('unbookPurchaseSeats', sc)
                })
              }
            })
          });

          await this.$store.dispatch('deleteCheckoutState', evento);
          if (checkoutState && checkoutState[evento] && checkoutState[evento].userToken) await this.$store.dispatch('getClientData')
          await this.$store.dispatch('loadCheckoutState', evento);
          await this.$store.dispatch('resetSelection');
          await this.$store.dispatch('setResetPurchase', false);
        },
    }
}
</script>
